<template>
  <div
    class="approvals-list-item d-flex align-center ga-2 px-8 py-6 w-100"
    role="button"
    tabindex="0"
    @click="handleClick"
    @keydown.enter="handleClick"
  >
    <div class="d-flex flex-column ga-1 flex-grow-1 min-w-0">
      <ApprovalStatusPill
        :status="flow.status"
        mode="overall"
      />

      <div class="text-h2 text-textDarkest">
        {{ formattedDate }}
      </div>

      <div class="text-body-2 text-textDark font-weight-medium">
        {{ templateName }}
      </div>
    </div>

    <div class="approvals-list-item-view-actions d-flex flex-shrink-0">
      <DpplNewButton
        variant="outlined"
        color="primary"
        height="32"
        class="approvals-list-item-view text-button-3"
        @click.stop="handleClick"
      >
        View
      </DpplNewButton>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import ApprovalStatusPill from '@/components/jobProfiles/editor/ApprovalStatusPill.vue';
import DpplNewButton from '@/components/datapeople/DpplNewButton.vue';
import {
  formatApprovalFlowDate,
  getTemplateNameByUlid,
} from '@/helpers/approvalFlows';

const props = defineProps({
  flow: {
    type: Object,
    required: true,
  },
  templates: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['click']);

const formattedDate = computed(() => formatApprovalFlowDate(props.flow?.created_at));

const templateName = computed(() => (
  getTemplateNameByUlid(props.templates, props.flow?.template_ulid)
));

const handleClick = () => {
  emit('click', props.flow);
};
</script>

<style scoped lang="less">
.approvals-list-item {
  background: @bg-default;
  border-bottom: 1px solid @stroke-default;
  cursor: pointer;

  &:hover {
    background: @bg-canvas;
  }

  &:hover .approvals-list-item-view-actions {
    opacity: 1;
    visibility: visible;
  }
}

.approvals-list-item-view-actions {
  opacity: 0;
  visibility: hidden;
}

.approvals-list-item-view {
  background-color: @bg-default;
}
</style>
